var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recruting"},[_c('p',[_vm._v(_vm._s(_vm.$t('process_of_recruting')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }